module.exports = __webpack_public_path__ + "static/eggucationRight-1fa3e098e1d77b4d4abbd472d176165e.webp";